module.exports = __webpack_public_path__ + "img/Number=50.a41565fb.png";